import d3 from "d3";

export class GraphCtrl {
    listValues:{ [id: string] : string[]; } = {};
    constructor(public $scope:any, public $uibModalInstance:angular.ui.bootstrap.IModalServiceInstance, public lineChart:LineChart) {
        $scope.vm = this;
    }
    options = {
        "chart": {
            "type": "lineChart",
            "height": 450,
            "margin": {
                "top": 20,
                "right": 20,
                "bottom": 40,
                "left": 55
            },
            x:function(d:any){
                //console.log("f.x="+d.x);
                var date = new Date(d.x);
                return date;
            },
            y:function(d:any){
                //console.log("f.y="+d.y);
                return d.y
            },
            "useInteractiveGuideline": true,
            "dispatch": {},
            "xAxis": {
                "axisLabel": this.lineChart.xAxis,
                "tickFormat":function(d:any){
                    return d3.time.format('%Y-%m-%d %H:%M:%S')(new Date(d));
                }
            },
            "yAxis": {
                "axisLabel": this.lineChart.yAxis,
                "axisLabelDistance": 30
            },
            "transitionDuration": 250
        },
        "title": {
            "enable": true,
            "text": this.lineChart.title
        },
    };
    ok() {
        this.$uibModalInstance.close(true);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

export class LineChart{
    constructor(public title:string, public xAxis:string,public yAxis:string, public lineData:LineData[]){
    }
}

export class LineData{
    constructor(public key:string,public values:LinePair[]){
    }
}

export class LinePair{
    constructor(public x:Date, public y:number){

    }
}
